import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "page__header",
  style: {"margin-top":"0","margin-bottom":"0"}
}
const _hoisted_2 = {
  class: "page__row",
  style: {"width":"40%","margin-right":"2rem"}
}
const _hoisted_3 = {
  key: 0,
  style: {"margin-left":"auto"}
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("+   Добавить рынки")
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  class: "btn",
  href: "/files/MARKET.xlsx",
  download: "",
  style: {"margin-left":"2rem"}
}, "Скачать пример файла", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", {
  class: "page__stats",
  style: {"margin-bottom":"1rem"}
}, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "page__header-title",
    style: {"margin-bottom":"1rem"}
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiInput = _resolveComponent("UiInput")!
  const _component_UiSelector = _resolveComponent("UiSelector")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_UiTable = _resolveComponent("UiTable")!
  const _component_ModalMarketNew = _resolveComponent("ModalMarketNew")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_UiInput, {
          label: "Наименование рынка",
          placeholder: "Введите",
          style: {"flex":"1 0 auto"},
          modelValue: _ctx.markets.filters.name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.markets.filters.name) = $event)),
          search: ""
        }, null, 8, ["modelValue"])
      ]),
      _createVNode(_component_UiSelector, {
        placeholder: "Выбрать УГНС",
        options: _ctx.ugnsSelector.options,
        modelValue: _ctx.markets.filters.ugnsId,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.markets.filters.ugnsId) = $event))
      }, null, 8, ["options", "modelValue"]),
      (!_ctx.$store.state.auth.isCA)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Btn, {
              size: "small",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.modalMarket.display = true))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _hoisted_5
          ]))
        : _createCommentVNode("", true)
    ]),
    _hoisted_6,
    _createVNode(_component_UiTable, {
      cols: _ctx.cols,
      rows: _ctx.markets.rows,
      "empty-banner-text": _ctx.markets.fetching ? 'Идет загрузка' : 'Нет данных'
    }, null, 8, ["cols", "rows", "empty-banner-text"]),
    (_ctx.modalMarket.display)
      ? (_openBlock(), _createBlock(_component_ModalMarketNew, {
          key: 0,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (_ctx.modalMarket.display = false))
        }))
      : _createCommentVNode("", true)
  ], 64))
}